// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nav {
  overflow: hidden;
  transition: height 0.2s ease-out;
}
.nav.collapsed {
  height: 0px;
}

.nav-link {
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/modules/navigation/components/side-nav-item-pro/side-nav-item-pro.component.scss"],"names":[],"mappings":"AAEA;EAEI,gBAAA;EACA,gCAAA;AAFJ;AAGI;EACI,WAAA;AADR;;AAKA;EACI,eAAA;AAFJ","sourcesContent":["@import 'styles/core/variables.scss';\n\n.nav {\n    // height: 96px;\n    overflow: hidden;\n    transition: height 0.2s ease-out;\n    &.collapsed {\n        height: 0px;\n    }\n}\n\n.nav-link {\n    cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
